export default __webpack_public_path__ + "static/media/mv.21c3b1ec.svg";